import * as React from 'react';
import WixStylesContext from '../../../context/wixStylesContext';
import { st, classes } from './WeeklyDesktopTodayBorder.st.css';
import WeeklyNowIndicator from '../WeeklyNowIndicatorDesktop';
var WeeklyDesktopTodayBorder = function () {
    var _a = React.useContext(WixStylesContext), cellBorderWidth = _a.cellBorderWidth, isResponsive = _a.isResponsive;
    var _b = React.useState(130), cellWidth = _b[0], setCellWidth = _b[1];
    var _c = React.useState(600), cellHight = _c[0], setCellHight = _c[1];
    var _d = React.useState(800), fcWidth = _d[0], setFcWidth = _d[1];
    var _e = React.useState(160), clientRectY = _e[0], setClientRectY = _e[1];
    var _f = React.useState(0), clientRectX = _f[0], setClientRectX = _f[1];
    var getCellWidth = function () {
        var fcEllem = document.getElementsByClassName('fc')[0];
        var todayCellHeight = fcEllem && fcEllem.scrollHeight;
        var fcWidth = fcEllem && fcEllem.clientWidth;
        setFcWidth(fcWidth);
        if (isResponsive) {
            setCellHight(todayCellHeight);
        }
        else {
            var prefixedBottomEl = document.getElementById('prefixedBottomPadding');
            var prefixedBottomBounding = prefixedBottomEl === null || prefixedBottomEl === void 0 ? void 0 : prefixedBottomEl.getBoundingClientRect();
            var daysHeaderHeight = 68.8;
            var controllersHeight = 84;
            daysHeaderHeight = getHeightByIdOrClassName('topPositionDatesWrapper', false, daysHeaderHeight);
            daysHeaderHeight = getHeightByIdOrClassName('calendarControllersRoot', false, controllersHeight);
            var calendarElemsHeight = prefixedBottomBounding &&
                prefixedBottomBounding.top - (daysHeaderHeight + controllersHeight);
            setCellHight(calendarElemsHeight || 800);
        }
        if (document.getElementsByClassName('fc-day-today').length > 0) {
            var todayCellWidth = document.getElementsByClassName('fc-daygrid-day-bg')[0].scrollWidth;
            //@ts-ignore
            var clientRectY_1 = document
                .getElementById('topPositionDatesWrapper')
                .getBoundingClientRect().bottom;
            var clientRectX_1 = document
                .getElementsByClassName('fc-day-today')[1]
                .getBoundingClientRect().x;
            setClientRectY(clientRectY_1);
            setClientRectX(clientRectX_1);
            var todayAllCellPrev = document.getElementsByClassName('fc-day-today')[0].previousSibling;
            if (todayAllCellPrev) {
                //@ts-ignore
                todayAllCellPrev.style.borderRight = 'none';
            }
            var todayAllCellNext = document.getElementsByClassName('fc-day-today')[0].nextSibling;
            if (todayAllCellNext) {
                //@ts-ignore
                todayAllCellNext.style.borderLeft = 'none';
            }
            var todayGreedCellPrev = document.getElementsByClassName('fc-day-today')[1].previousSibling;
            if (todayGreedCellPrev) {
                //@ts-ignore
                todayGreedCellPrev.style.borderRight = 'none';
            }
            var todayGreedCellNext = document.getElementsByClassName('fc-day-today')[1].nextSibling;
            if (todayGreedCellNext) {
                //@ts-ignore
                todayGreedCellNext.style.borderLeft = 'none';
            }
            setCellWidth(todayCellWidth);
        }
    };
    React.useEffect(function () {
        getCellWidth();
        window.addEventListener('resize', function () { return getCellWidth(); });
        return function () { return window.addEventListener('resize', function () { return getCellWidth(); }); };
    });
    React.useEffect(function () {
        getCellWidth();
    }, [cellBorderWidth]);
    var todayFrameWidth = cellWidth - cellBorderWidth * 2 + 1;
    var leftPosition = clientRectX;
    if (cellBorderWidth === 2) {
        todayFrameWidth = cellWidth - cellBorderWidth * 2;
        leftPosition = clientRectX;
    }
    if (cellBorderWidth === 3) {
        todayFrameWidth = cellWidth - cellBorderWidth * 2 + 1;
        leftPosition = clientRectX;
    }
    var bottomPosition = cellHight + clientRectY - cellBorderWidth;
    var frameHeight = isResponsive
        ? cellHight - cellBorderWidth * 2
        : cellHight - cellBorderWidth * 2;
    return (React.createElement(React.Fragment, null,
        React.createElement(WeeklyNowIndicator, { cellWidth: cellWidth, clientRectX: clientRectX, clientRectY: clientRectY, bottomPosition: bottomPosition }),
        React.createElement("div", { className: st(classes.TodayBorder), style: {
                position: 'absolute',
                width: "".concat(todayFrameWidth, "px"),
                height: "".concat(frameHeight, "px"),
                zIndex: 10,
                top: "".concat(clientRectY, "px"),
                left: "".concat(leftPosition, "px"),
                pointerEvents: 'none',
            } })));
};
export default WeeklyDesktopTodayBorder;
var getHeightByIdOrClassName = function (artifact, isClassName, defaultValue) {
    var height = defaultValue;
    var ell = isClassName
        ? document.getElementsByClassName(artifact)[0]
        : document.getElementById(artifact);
    var ellBoundingClientRect = ell && ell.getBoundingClientRect();
    height = (ellBoundingClientRect === null || ellBoundingClientRect === void 0 ? void 0 : ellBoundingClientRect.height) || defaultValue;
    return height;
};
//# sourceMappingURL=WeeklyDesktopTodayBorder.js.map